import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { CommonResult } from '../../../external/Common';
import { actions } from '../../modules/Actions';

export interface MailSaveState {
  result: CommonResult;
}

export const initialState: MailSaveState = {
  result: {
    jobDateTime: '',
    resultCd: ''
  }
};

export const MailSaveReducer = reducerWithInitialState(initialState)
  .case(
    actions.saveMailDraft, (state: MailSaveState, payload: MailSaveState) => {
      return payload;
    }
  );
